<template>
	<div>
		<productCenNav ref="productCenNav" :list="navList" @goScroll="goScroll" v-show="cenNavHidden"></productCenNav>
		<productCenTil ref="njxt" :name="$t('配套产品')"></productCenTil>
		<productCenList ref="njxtList" :list="njxtList"></productCenList>
		<productCenTil ref="dznj" :name="$t('一体化设计')"></productCenTil>
		<productCenList ref="dznjList" :list="dznjList"></productCenList>
		<productCenTil ref="zbcp" :name="$t('高画质')"></productCenTil>
		<productCenList ref="zbcpList" :list="zbcpList"></productCenList>
	</div>
</template>

<script>
	import productCenNav from "./productCenNav"
	import productCenTil from "./productCenTil"
	import productCenList from "./productCenList"
	
	export default {
		components: {
			productCenNav,
			productCenTil,
			productCenList
		},
		data() {
			return {
				navList: [
					{
						name: this.$t('功能强大'),
						value: 'njxt',
					},
					{
						name: this.$t('LED光源高续航'),
						value: 'dznj',
					},
					{
						name: this.$t('配套产品'),
						value: 'zbcp',
					},
				],
				navHidden: false,
				scrollTop: 0,
				scrollTopNav: 0,
				cenNavHidden: true,
				navTop:[],
				njxtList:[
					// {
					// 	title:'',
					// 	list:[
					// 		// {
					// 		// 	img:require('@/assets/content/cpImg.png'),
					// 		// 	name:'AQ-300 4K超高清内镜解决方案'
					// 		// },
					// 		// {
					// 		// 	img:require('@/assets/content/cpImg.png'),
					// 		// 	name:'AQ-300 4K超高清内镜解决方案'
					// 		// },
					// 		// {
					// 		// 	img:require('@/assets/content/cpImg.png'),
					// 		// 	name:'AQ-300 4K超高清内镜解决方案'
					// 		// },
					// 		// {
					// 		// 	img:require('@/assets/content/cpImg.png'),
					// 		// 	name:'AQ-300 4K超高清内镜解决方案'
					// 		// },
					// 	]
					// },
				],
				dznjList:[
					// {
					// 	title:'消化科',
					// 	list:[
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 	]
					// },
					// {
					// 	title:'鼻咽喉科',
					// 	list:[
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 	]
					// }
				],
				zbcpList:[
					// {
					// 	title:'',
					// 	list:[
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 		{
					// 			img:require('@/assets/content/cpImg.png'),
					// 			name:'AQ-300 4K超高清内镜解决方案'
					// 		},
					// 	]
					// },
				],
				querValue:''
			}
		},
		watch: {
			scrollTop() {
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v,a)=>{
					if(a+1==this.navList.length){
						if ((this.scrollTop+70) > this.navTop[a]) {
							this.$refs.productCenNav.current=a;
						}
					}else{
						if ((this.scrollTop+70) > this.navTop[a]&&(this.scrollTop+70)< this.navTop[a+1]) {
							this.$refs.productCenNav.current=a;
						}
					}
					
					// if(!this.navHidden){
					// 	if (offsetTop > this.navTop[a]&&offsetTop< this.navTop[a+1]) {
					// 		this.$refs.productCenNav.current=a;
					// 	}
					// 	return;
					// }
					// if (offsetTop > this.scrollTop) {
					// 	this.$refs.productCenNav.current=a
					// }
				})
			},
			querValue(){
				let t=this;
				console.log(this.querValue)
				this.$nextTick(function(){
					t.setTop();
				})
			},
			navTop(){
				let t=this;
				t.setTop();
			}
		},
		
		mounted() {
			let t=this;
			let offsetTop = this.$refs.productCenNav.$el.offsetTop;
			this.scrollTopNav = offsetTop;
			window.addEventListener('scroll', this.handleScroll);
			this.querValue=this.$route.query.value;
			this.$nextTick(function(){
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				t.scrollTop = element.scrollTop;
				t.getTop();
			})
			this.$refs.productCenNav.setList(this.navList);
			console.log(this.querValue,"嗷嗷")
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			setTop(){
				this.navList.map((v,a)=>{
					if(this.querValue==v.value){
						this.$refs.productCenNav.current=a;
						this.goScroll(this.querValue)
					}
					
				})
			},
			getTop(){
				let top=[];
				this.navList.map((v,a)=>{
					top.push(this.$refs[v.value].$el.offsetTop)
				})
				this.$nextTick(function() {
					console.log(this.navTop)
					this.navTop = top;
				})
			},
			goScroll(e) {
				let offsetTop = this.$refs[e].$el.offsetTop - 70;
				this.$emit('goScroll',offsetTop)
				// document.documentElement.scrollTop = offsetTop+10;
			},
			handleScroll(e) {
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				this.scrollTop = element.scrollTop;
				// console.log(this.scrollTop)
			},
			setList(e){
				let t=this;
				if(e[0]){
					if(e[0].child.length>0){
						this.njxtList=e[0].child
					}else{
						this.njxtList=[
							{
								product_list:[]
							}
						]
						this.njxtList[0].product_list=e[0].product_list
					}
				}
				if(e[1]){
					if(e[1].child.length>0){
						this.dznjList=e[1].child
					}else{
						this.dznjList=[
							{
								product_list:[]
							}
						]
						this.dznjList[0].product_list=e[1].product_list
					}
				}
				if(e[2]){
					if(e[2].child.length>0){
						this.zbcpList=e[2].child
					}else{
						this.zbcpList=[
							{
								product_list:[]
							}
						]
						this.zbcpList[0].product_list=e[2].product_list
					}
				}
				this.$nextTick(function(){
					t.getTop();
					this.$refs.productCenNav.current=0;
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">

</style>